export class Location {
    locationId: number;
    postalCode: string;
    locationName: string;
}
